import React, { useState } from 'react'
import Add from './add'
import Grid from './grid'
import { AccordionWithArrow } from '../../../../components'
import { consoleLog } from '../../../../util'
import { Wrapper } from './style'

const SubKeywordCount = () => {
  const [updatedData, setUpdatedData] = useState([])

  const updatedDataFunc = (array) => {
    consoleLog(array)
    setUpdatedData(array)
  }

  return (
    <Wrapper>
        <AccordionWithArrow title='Sub Keyword Count' expanded={true} accordionstyle='fieldset'>
            <Add onChange={updatedDataFunc} />
            <Grid gridData={updatedData} />
        </AccordionWithArrow>
    </Wrapper>
  )
}

export default SubKeywordCount
